import React from 'react'
import {Global, css} from '@emotion/core'
import {withTheme} from 'emotion-theming'

const GlobalStyles = ({theme}) => <Global styles={css`
	body {
		overflow: hidden;
	}
	html, body, #___gatsby, #___gatsby > * {
		min-height: 100vh;
	}

	* {
		box-sizing: border-box;
	}

	a {
		text-decoration: none;
		color: black;
		font-weight: ${theme.fontWeights.bold};

		&:hover {
			text-decoration: underline;
		}
	}


	@media only screen and (max-width: 700px) {
		h1 {
			font-size: ${theme.fontSizes.big30};
		}
		h2 {
			font-size: ${theme.fontSizes.big25};
		}
		h3 {
			font-size: ${theme.fontSizes.big20};
		}
	}
`}/>

GlobalStyles.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
}

export default withTheme(GlobalStyles)
